import { render, staticRenderFns } from "./SaleSummary.vue?vue&type=template&id=f1a96dfa&scoped=true"
import script from "./SaleSummary.vue?vue&type=script&lang=js"
export * from "./SaleSummary.vue?vue&type=script&lang=js"
import style0 from "./SaleSummary.vue?vue&type=style&index=0&id=f1a96dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a96dfa",
  null
  
)

export default component.exports